import { gql } from '@apollo/client'

export const GQL_QUERY_MAIN_PAGE_CONFIG = gql`
  query MainPageConfig($id: ID, $ignoreCache: Boolean, $type: String) {
    mainPageConfig(id: $id, ignoreCache: $ignoreCache, type: $type) {
      id
      blocks {
        type
        subtype
        order
        payload
      }
    }
  }
`
